<h1 mat-dialog-title class="p-2 text-center">{{model.QuestionTitle}}</h1>
<div class="row g-0">
    @if (model.WithReason) {
    <mat-form-field class="col-12 p-3">
        <textarea matInput i18n-placeholder placeholder="message" [(ngModel)]="model.Reason" cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5" [formControl]="ValidReasonMaxLength"></textarea>
        <mat-hint align="end">{{model.Reason?.length || 0}}/{{REASON_MAX_SIZE}}</mat-hint>
        @if (ValidReasonMaxLength.hasError('maxlength')) {
        <mat-error i18n>
            Texte trop long
        </mat-error>
        }
    </mat-form-field>
    }
    <button appPreventDoubleClick class="col-6 squared-flat-button" color="primary" mat-stroked-button (throttledClick)="onCancel()" i18n>
        Non
    </button>
    <button appPreventDoubleClick [disabled]="ValidReasonMaxLength.hasError('maxlength')" class="col-6 squared-flat-button" color="warn" mat-stroked-button (throttledClick)="onConfirm()" i18n>
        Oui
    </button>
</div>